import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { IOption } from "../components/ui/Input/Input";
import { ErrorResponse } from "../custom-fetch";
import { QueryKey } from "../services/query-keys";
import { useBookingService } from "../services/booking-service";
import { IWheelsStation } from "../shared/IReservation";

export const useStationOptions = () => {
  const { fetchStations } = useBookingService();

  const {
    data: stations,
    isPending,
    isError,
  } = useQuery<IWheelsStation[], ErrorResponse>({
    queryKey: [QueryKey.stations],
    queryFn: ({ signal }) => fetchStations({ signal }),
    staleTime: Infinity,
  });

  const returnOptions = useMemo(
    () =>
      isError
        ? []
        : stations
          ?.filter((s) => s.code !== "MAIN")
          .map((s) => ({ value: s.code, label: s.name } as IOption)),
    [stations, isError]
  );

  const pickupOptions = useMemo(
    () => {
      if (isError || !stations) return [];

      const blacklist = ["TRD", "EVE", "MAL", "RIG", "SCOT", "MAIN", "MAD"];
      return stations
        .filter((s) => !blacklist.includes(s.code))
        .filter((s) => !s.name.toLowerCase().includes("drop-off") && !s.name.toLowerCase().includes("drop off"))
        .map((s) => ({ value: s.code, label: s.name } as IOption));
    },
    [stations, isError]
  );

  return {
    pickupOptions,
    returnOptions,
    loading: isPending,
    stations
  };
};
